import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  procedureId: yup.number().required(),
  productId: yup.number().required(),
  chartingPackageId: yup.number().required(),
  quantity: yup.number().required(),
});

export function useUpdateProcedureChartingProductMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });

    return http.post(HTTP_ENDPOINTS.mutateProcedureChartingProduct(), {
      procedure_id: req.procedureId,
      product_id: req.productId,
      charting_package_id: req.chartingPackageId,
      quantity: req.quantity,
    });
  }, options);
}
